import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import React, { Suspense } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Label,
  Segment,
  Form,
  Input,
  Button,
  Checkbox,
} from 'semantic-ui-react';
import {
  TemplateSubTasks,
  WorkflowElement,
} from '../../../app/models/template';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../../app/stores/store';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import {
  cardcolor,
  errorDot,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import WorkflowSettings from './WorkflowSettings';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import agent from '../../../app/api/agent';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel3 = {
  display: 'inline-block',
  padding: '10px',
  height: '68vh',
  width: '200pt',
  marginTop: '130px',
  color: 'black',
  marginLeft: '-12px',
  boxShadow: '5px 5px 10px lightgray',
};

function WorkflowElements() {
  const {
    TemplateStore,
    workflowConfigurationStore,
    RolesAndPermissionsIDStore,
    userStore,
    modalStore,
    activityStore,
    commonStore,
  } = useStore();
  const {
    selectedSubTasks,
    createElementUnderSubtask,
    selectedElement,
    loadElementById,
    loadingInitialElem,
    cloneElements,
    selectedTemplate,
    editElements,
    elementToggleOffEdit,
    deleteElements,
  } = TemplateStore;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [getreportskey, setgetreportskey] = useState<string | null>();
  const [newElements, setNewElements] = useState('');
  const [subTaskElements, setSubTaskElements] = useState<
    WorkflowElement[] | undefined
  >(selectedSubTasks?.elements);
  const [errorType, setErrorType] = useState<string>('');
  const [deleteOption, setDeleteOption] = useState<WorkflowElement>({
    elementValue: '',
    elementId: '',
    elementName: '',
    elementType: '',
    elementDateTime: '',
    creatorName: '',
    elementIndex: 0,
    isActive: false,
    isDeleted: false,
    options: [],
    enableByDefault: false,
    validation: '',
    files: [],
    photos: [],
    templateElementId: '',
    readOnly: false,
    isMandatory: false,
    parentId: '',
  });

  useEffect(() => {
    setErrorType('');
    setSubTaskElements(selectedSubTasks?.elements);
  }, [selectedSubTasks]);

  ///////// /////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedElement ===
        false &&
      errorType !== '' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      hanldeAddElements();
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedElement ===
        true &&
      errorType !== '' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      handleSaveEdited('edit');
    }
  };

  const handleElement = (e: any, id: string) => {
    setErrorType('');
    loadElementById(id);
    workflowConfigurationStore.setShowElementName(id);
    workflowConfigurationStore.resetEditClickedButtonExceptElements();
  };
  const hanldeAddElements = () => {
    if (
      selectedSubTasks &&
      selectedTemplate !== undefined &&
      newElements.length !== 0 &&
      // errorType !== '' &&
      !/\s/g.test(newElements?.charAt(0) || '')
    ) {
      const elements = selectedSubTasks?.elements;
      const IdForReference = uuid();
      const newArr: any = {
        elementId: IdForReference,
        elementName: newElements,
        elementDateTime: activityStore.updateDateTime(),
        creatorName:
          userStore.user?.username !== undefined
            ? userStore.user?.username
            : 'bob',
        elementValue: '',
        elementType: 'TextBox',
        elementIndex: elements.length,
        isActive: true,
        templateElementId: IdForReference.toString(),
        options: [],
        enableByDefault: false,
        isDeleted: false,
        validation: '',
        files: [],
        photos: [],
        dynamicTypeId: '',
        readOnly: false,
      };
      const selectedSubTasksArr: any = {
        // for backend
        ...selectedSubTasks,
        elements: [newArr],
      };
      elements.push(newArr); // for front end schema
      const AllvaluefrontEndData = {
        // for front end schema
        ...selectedSubTasks,
        elements: elements,
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: IdForReference,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      createElementUnderSubtask(selectedSubTasksArr, AllvaluefrontEndData);
      sendRespectiveEmail('created', newArr.elementName, 'Created Element', ''); //email Function
      RolesAndPermissionsIDStore.createRoleID(newRoleArr); //roles and permissions
    } else {
      setErrorType('EmptyName');
    }
    setNewElements(''); // set value to empty
  };
  const toggleOnElements = (
    event: SyntheticEvent,
    data: any,
    element: WorkflowElement,
  ) => {
    elementToggleOffEdit(element.elementId);
  };
  //////////////////////// clone
  const handleClone = () => {
    let flag = 0;
    selectedSubTasks?.elements?.forEach((data) => {
      if (data.elementId === selectedElement?.elementId) {
        flag = 1;
      }
    });
    if (
      selectedSubTasks &&
      selectedElement !== undefined &&
      newElements.length > 0 &&
      errorType !== '' &&
      !/\s/g.test(newElements?.charAt(0) || '') &&
      flag
    ) {
      cloneElements({
        id: selectedSubTasks.subTaskId,
        cloned_from: selectedElement.elementId,
        cloned_as: newElements,
      });
      sendRespectiveEmail('cloned', newElements, 'Cloned Element', ''); //email Function
    } else if (!flag) {
      setErrorType('selectionEmpty');
    } else if (newElements.length === 0) {
      setErrorType('EmptyName');
    }
    setNewElements('');
  };
  ////////////////////////Drag and Drop
  const onDragEnd = async (result: DropResult) => {
    loadElementById(result.draggableId);
    if (subTaskElements) {
      const { source, destination } = result;
      if (!destination) return;
      let copySubTaskElements = [...subTaskElements];
      let elementId = copySubTaskElements[source.index].elementId;
      copySubTaskElements.splice(source.index, 1);
      copySubTaskElements.splice(
        destination.index,
        0,
        subTaskElements[source.index],
      );

      for (
        let i = destination.index;
        i < copySubTaskElements?.length || 0;
        i++
      ) {
        copySubTaskElements[i].elementIndex = i;
      }

      if (TemplateStore.selectedSubTasks)
        TemplateStore.selectedSubTasks.elements = copySubTaskElements;

      let payload = {
        elementId,
        startIndex: source.index,
        endIndex: destination.index,
      };
      setSubTaskElements(copySubTaskElements);
      let params = {
        startIndex: payload.startIndex,
        endIndex: payload.endIndex,
      };
      await agent.TemplateSubtasks.reArrangeOrder(params, payload.elementId);
    }
  };
  ///////////////////////edit clicked
  const handleEdit = (id: string, name: string) => {
    setErrorType('');
    loadElementById(id);
    setNewElements(name);
    workflowConfigurationStore.setEditClickedElement(true);
  };
  ///////////////////////// Save Edited
  const handleSaveEdited = (name: string) => {
    if (errorType === 'SameName' && name === 'edit') {
      return;
    }
    if (
      selectedElement &&
      selectedSubTasks !== undefined &&
      name === 'edit' &&
      newElements.length !== 0
    ) {
      const newArr = {
        ...selectedElement,
        elementName: newElements,
      };
      editElements(newArr);
      sendRespectiveEmail('edited', newArr.elementName, 'Edited Element', ''); //email Function
      //to update dom
      const data = selectedSubTasks?.elements;
      const index = data.findIndex(
        (obj) => obj.elementId === selectedElement.elementId,
      );
      if (data?.[index]) data[index].elementName = newElements;
    }
    setNewElements('');
    workflowConfigurationStore.setEditClickedElement(false);
  };
  ////////////////////////////handle Change
  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setErrorType('');
    setNewElements(data.value);
    const NameCheck = subTaskElements?.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b.trim(), undefined, {
              sensitivity: 'accent',
            }) === 0
          : a.trim() === b.trim();
      }
      return ciEquals(el.elementName, data.value);
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
    if (data.value.includes('.')) {
      setErrorType('dot');
    }
  };

  const handleWorkflowSettings = (id: string, elements: WorkflowElement) => {
    setErrorType('');
    loadElementById(id);
    modalStore.openModal(
      <WorkflowSettings
        elements={elements}
        elementsNames={(subTaskElements || [])?.flatMap((data) =>
          data.elementName !== elements.elementName
            ? {
                key: data.elementId,
                value: data.elementName,
                text: data.elementName,
              }
            : [],
        )}
      />,
    );
  };

  /////////////////////////////////
  const handleDeleteElement = (element: WorkflowElement) => {
    if (selectedSubTasks !== undefined) {
      setErrorType('');
      setIsModalOpen(true);
      setDeleteOption(element);
    }
  };

  const deleteConfirmed = () => {
    const elementDatas = selectedSubTasks?.elements;
    const elementArr = {
      ...deleteOption,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData =
      elementDatas !== undefined
        ? elementDatas.filter(
            (item) => item.elementId !== deleteOption?.elementId,
          )
        : [];

    const AllvaluefrontEndData = {
      ...selectedSubTasks,
      elements: filterData,
    };
    deleteElements(elementArr, AllvaluefrontEndData as TemplateSubTasks);
    sendRespectiveEmail(
      'deleted',
      elementArr.elementName,
      'Deleted Element',
      '',
    ); //email Function
    setIsModalOpen(false);
  };
  const ElementJSX = (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div
            className="templatepreset workflow-config-elements"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {subTaskElements?.map((elements, index) => {
              return (
                <Draggable
                  key={elements.elementId}
                  draggableId={elements.elementId}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <Card.Content
                          onMouseEnter={() =>
                            setgetreportskey(elements.elementId)
                          }
                          onMouseLeave={() => setgetreportskey(null)}
                          style={
                            elements.elementId ===
                            workflowConfigurationStore.WorkflowConfiguration
                              .showElementName
                              ? cardcolor
                              : null
                          }
                          key={elements.elementId}
                        >
                          <Grid className="hoverColor" columns={3}>
                            <Grid.Row>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                {getreportskey === elements.elementId ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                    {...provided.dragHandleProps}
                                  >
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        left: 7,
                                        position: 'absolute',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                  </div>
                                ) : null}
                              </Grid.Column>
                              <Grid.Column
                                onClick={(e: any) =>
                                  handleElement(e, elements.elementId)
                                }
                                width={12}
                              >
                                {elements.elementName}
                              </Grid.Column>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                <Checkbox
                                  key={index}
                                  style={{
                                    marginTop: '-3px',
                                    marginLeft: '-10px',
                                  }}
                                  onChange={(e: any, data: any) =>
                                    toggleOnElements(e, data, elements)
                                  }
                                  name={elements.elementName}
                                  className="table-toggle"
                                  toggle
                                  defaultChecked={
                                    elements.isActive ? true : false
                                  }
                                />
                              </Grid.Column>
                              {getreportskey === elements.elementId ? (
                                <Label
                                  attached="bottom right"
                                  style={{
                                    width: '92px',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                >
                                  <Grid>
                                    <Grid.Row
                                      style={{
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="pencil"
                                          color="grey"
                                          size="small"
                                          onClick={() =>
                                            handleEdit(
                                              elements.elementId,
                                              elements.elementName,
                                            )
                                          }
                                        />{' '}
                                      </Grid.Column>
                                      <Grid.Column>
                                        {' '}
                                        <Icon
                                          name="trash"
                                          color="grey"
                                          size="small"
                                          onClick={() =>
                                            handleDeleteElement(elements)
                                          }
                                        />{' '}
                                      </Grid.Column>
                                      <Grid.Column>
                                        <Icon
                                          onClick={() =>
                                            handleWorkflowSettings(
                                              elements.elementId,
                                              elements,
                                            )
                                          }
                                          // onClick={() => mediaAssetStore.settingsFormOpen( true ) }
                                          name="setting"
                                          color="grey"
                                          size="small"
                                        />
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </Label>
                              ) : null}
                            </Grid.Row>
                          </Grid>
                        </Card.Content>
                      </Card>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );

  return (
    <div>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={'Are you sure you want to delete this? '}
          />
        </Suspense>
      )}
      <Card style={cardStyleLevel3}>
        <Header
          style={{ marginLeft: '20px', padding: '10px' }}
          size="huge"
          as="h1"
          content="Components"
          sub
          color="grey"
        />
        {!selectedSubTasks || loadingInitialElem ? (
          <LoadingComponent />
        ) : (
          ElementJSX
        )}

        <Segment className="workflow-bottom-card">
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                id="form-input-control-error-email"
                className=" workflow-input"
                error={
                  errorType === 'SameName'
                    ? errorMessageText
                    : errorType === 'EmptyName'
                      ? errorEmptyText
                      : errorType === 'dot'
                        ? errorDot
                        : errorType === 'selectionEmpty'
                          ? selectionEmptyErrorMsg
                          : null
                }
                control={Input}
                value={newElements}
                placeholder="Create New"
                onChange={handleChangeName}
                onKeyDown={handleKeyPress}
              />
            </Form.Group>
          </Form>
          {workflowConfigurationStore.WorkflowConfiguration
            .editClickedElement === false ? (
            <div className="workflow-input-div">
              {commonStore.filterModeTwo?.includes('SWB08') ? (
                <></>
              ) : (
                <Button
                  primary
                  onClick={handleClone}
                  className="workflow-input-button"
                  disabled={
                    commonStore.filterModeZero?.includes('SWB08') ||
                    errorType !== ''
                  }
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'selectionEmpty'
                          ? selectionEmptyErrorMsg
                          : null
                  }
                >
                  {' '}
                  Clone
                </Button>
              )}

              {/* <Button primary onClick={handleClone} className="workflow-input-button"
                              disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB08")?true:false ||
                              errorType === "SameName" || errorType === "EmptyName" ? true : false }
                               error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}> Clone</Button> */}

              {commonStore.filterModeTwo?.includes('SWB06') ? (
                <></>
              ) : (
                <Button
                  color="green"
                  floated="right"
                  onClick={hanldeAddElements}
                  disabled={
                    commonStore.filterModeZero?.includes('SWB06') ||
                    errorType !== ''
                  }
                  className="workflow-input-button"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'selectionEmpty'
                          ? selectionEmptyErrorMsg
                          : null
                  }
                >
                  Add New
                </Button>
              )}

              {/* <Button color="green" floated='right' onClick={hanldeAddElements} 
                             disabled={!dashboardStore.dashboard.selectedUserRoleId.includes("SWB06")?true:false
                             ||errorType === "dot" ||errorType === "SameName" || errorType === "EmptyName" ? true : false }  
                              className="workflow-input-button" error={errorType==='SameName'?errorMessageText:errorType==='EmptyName'?errorEmptyText:null}>Add New</Button> */}
            </div>
          ) : (
            <div className="workflow-input-div">
              <Button
                secondary
                onClick={() => handleSaveEdited('cancel')}
                className="workflow-input-button"
              >
                {' '}
                Cancel
              </Button>
              <Button
                primary
                floated="right"
                onClick={() => handleSaveEdited('edit')}
                className="workflow-input-button"
                error={
                  errorType === 'SameName'
                    ? errorMessageText
                    : errorType === 'EmptyName'
                      ? errorEmptyText
                      : errorType === 'selectionEmpty'
                        ? selectionEmptyErrorMsg
                        : null
                }
              >
                Save
              </Button>
            </div>
          )}
        </Segment>
      </Card>
    </div>
  );
}

export default observer(WorkflowElements);
